import { useTranslation } from 'react-i18next';
import {
  colors,
  NewTypography as Typography,
  useViewport,
} from '@lamimed/pantheon';

import * as S from './styles';

export type Variant = 'nomore' | 'empty' | 'nodocuments';

type VariantContent = {
  [key in Variant]: {
    title: string;
    description: string;
  };
};

interface NoAppointmentsProps {
  variant?: Variant;
}

export function NoAppointments({ variant = 'empty' }: NoAppointmentsProps) {
  const { lessThan } = useViewport();
  const { t } = useTranslation();

  const content: VariantContent = {
    empty: {
      title: t('page--patient-area.noAppointmentsTitle'),
      description: t('page--patient-area.noAppointmentsDescription'),
    },
    nomore: {
      title: t('page--patient-area.noMoreAppointmentsTitle'),
      description: t('page--patient-area.noMoreAppointmentsDescription'),
    },
    nodocuments: {
      title: t('page--patient-area.noAppointmentsDocumentsTitle'),
      description: t('page--patient-area.noAppointmentsDocumentDescription'),
    },
  };

  return (
    <S.Container variant={variant}>
      <S.ScrollIcon size={40} color={colors.dark} strokeWidth={1} />

      <Typography
        variant={lessThan('tablet') ? 'body_text_2' : 'body_text_3'}
        fontWeight="medium"
        marginBottom="none"
      >
        {content[variant].title}
      </Typography>

      <Typography variant="body_text_3" marginBottom="none">
        {content[variant].description}
      </Typography>
    </S.Container>
  );
}
